import { v4 as uuidv4 } from "uuid";
import type { Config } from "../types";
import type { UrlParameters } from "../bootstrap/urlParameters";
import type { RedirectParameters } from "../@api/config";

export const generateNonce = (): string => uuidv4();

export const getValueWithKeyFromSearch = (
  search: string,
  key: string,
): string | null => {
  const params = new URLSearchParams(search);
  return params.get(key);
};

export const SEARCH_CODE = "code";
export const SEARCH_STATE = "state";
const SEARCH_CLIENT_ID = "client_id";
const SEARCH_REDIRECT_URI = "redirect_uri";
const SEARCH_REDIRECT_URI_LOGIN = "redirect_uri_login";
const SEARCH_RESPONSE_TYPE = "response_type";
export const SEARCH_ERROR = "error";
export const SEARCH_ACR = "acr_values";

function safeDecodeURIComponent(toDecode: string) {
  try {
    // decode twice due to iOS issue
    return decodeURIComponent(decodeURIComponent(toDecode));
  } catch (_) {
    return "";
  }
}

export const getRedirectParametersFromSearchWithConfig = (
  search: string,
  config: Config,
): RedirectParameters => ({
  appClientId: getValueWithKeyFromSearch(search, SEARCH_CLIENT_ID) ||
    config.oauth_default_client_id,
  redirectState: getValueWithKeyFromSearch(search, SEARCH_STATE) || "intro",
  redirectUri: safeDecodeURIComponent(
    getValueWithKeyFromSearch(search, SEARCH_REDIRECT_URI) ||
      config.oauth_default_redirect_uri,
  ),
  responseType: getValueWithKeyFromSearch(search, SEARCH_RESPONSE_TYPE) ||
    config.oauth_response_type,
  redirectUriLogin: safeDecodeURIComponent(
    getValueWithKeyFromSearch(search, SEARCH_REDIRECT_URI_LOGIN) || "",
  ),
});

export const convertUrlParametersToBase64 = (
  values: Omit<UrlParameters, "isStrongAuthReturn">,
): string => encodeURIComponent(btoa(JSON.stringify(values)));

export const convertUrlParametersFromBase64 = (
  stateString: string,
  config: Config,
): Omit<UrlParameters, "isStrongAuthReturn"> => {
  try {
    return JSON.parse(atob(decodeURIComponent(stateString)));
  } catch {
    return {
      redirectParameters: getRedirectParametersFromSearchWithConfig(
        "",
        config,
      ),
    };
  }
};
